define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/data-sources/attributes/attributesConfigItemView.tmpl");
    var ScraperView = require("manager-views/data-sources/attributes/ScraperView");
    var ScraperNotSupportedView = require("manager-views/data-sources/attributes/ScraperNotSupportedView");
    var CodeView = require("manager-views/data-sources/attributes/CodeView");
    var AgentView = require("manager-views/data-sources/attributes/AgentView");
    var TooltipContainerView = require("manager-views/data-sources/attributes/TooltipContainerView");
    var Bubble = require("ui/bubble/Bubble");
    var Loader = require("ui/loader/Loader");

    var ManagerConfig = require("manager-assets/config/managerConfig.json");

    var AttributesConfigItemView = {};
    var scraperBubbleId = "scraperBubble";
    var codeBubbleId = "codeBubble";

    LE.module('LEManager', function (LEManager, LE, Backbone, Marionette, $, _) {

        AttributesConfigItemView = Marionette.ItemView.extend({

            template:template,
            className:'data-source-edit-item-container',
            withUIComponents: true,
            ui:{
                "scraperTab": ".tab.scraper",
                "codeTab": ".tab.code",
                "agentTab": ".tab.agent",
                "scraperContainer": ".tab-content-wrap.scraper",
                "codeContainer": ".tab-content-wrap.code",
                "agentContainer": ".tab-content-wrap.agent",
                "scraperTooltipContainer": ".tab.scraper .tab-bubble-caption",
                "codeTooltipContainer": ".tab.code .tab-bubble-caption",
                "agentTooltipContainer": ".tab.agent .tab-bubble-caption",
                "dataIndicatorIcon": ".icon",
                "header": ".header"
            },

            events: {
                "click .tab.scraper": "toggleScrapperTab",
                "click .tab.code": "toggleCodeTab",
                "click .tab.agent": "toggleAgentTab",
                "mouseenter .tab.scraper .tab-bubble-caption": "showScraperTooltip",
                "mouseleave .tab.scraper .tab-bubble-caption": "hideScraperTooltip",
                "mouseenter .tab.code .tab-bubble-caption": "showCodeTooltip",
                "mouseleave .tab.code .tab-bubble-caption": "hideCodeTooltip",
                "mouseenter .tab.agent .tab-bubble-caption": "showAgentTooltip",
                "mouseleave .tab.agent .tab-bubble-caption": "hideAgentTooltip"
            },

            uiComponents:{
                codeView: {
                    type: CodeView,
                    options: {
                        el: "view.ui.codeContainer",
                        model: "view.getModel"
                    }
                }
            },

            //--------------------------------------------------
            // initialize
            //--------------------------------------------------

            initialize: function(options){
                LEManager.logger.debug("AttributesConfigItemView:initialize");
                this.channel = LEManager.media.channel("dataSources");
                this.listenTo(this.model, 'change:connections', this._onConnectedStateChange);
                this.skillsCollection = options.skillsCollection;
            },

            customTemplateHelpers: function() {
                //var that = this;
                return {
                    itemName: this.model.getName(),
                    itemDescription: this.model.getDescription(),
                    logicalName: this.model.getLogicalName(),
                    hasScraperTab: this.model.hasScraperTab(),
                    hasCodeTab: this.model.hasCodeTab(),
                    hasAgentTab: !!this.model.getAgentOutcome()
                };
            },

            onRender: function(){
                LEManager.logger.debug("AttributesConfigItemView:onRender");
                var hideScrapper = this.model.hasNoServices() || !this.model.hasScraperTab();
                var hideAgent = this.model.hasNoServices() || !this.model.getAgentOutcome();
                this._hideShowAgentArea(hideAgent);
                this._hideShowScrapperArea(hideScrapper);
            },

            _onConnectedStateChange: function(){
                LEManager.logger.debug("AttributesConfigItemView:_onConnectedStateChange");
                this.ui.dataIndicatorIcon.removeClass("hide");
                this.ui.dataIndicatorIcon.attr("title", this.getIndicatorIconTooltip());
                if (this.model.isConnected()){
                    LEManager.logger.debug("AttributesConfigItemView:onRender - this.model.isConnected() is true");
                    this.ui.header.addClass("connected");
                }
            },

            getIndicatorIconTooltip: function(){
                LEManager.logger.debug("AttributesConfigItemView:getIndicatorIconTooltip");
                var tooltipText = LE.translator.translate("LEManager.manager.dataSources.edit.connected.indicator.tooltip.noData");

                if(this.model.isConnected()){
                    tooltipText = LE.translator.translate("LEManager.manager.dataSources.edit.connected.indicator.tooltip." + this.model.getLogicalName());
                }
                else if(this.model.hasNoServices()){ //this is a temporary code for adding the section EA while the backend is not yet ready
                    tooltipText = this.model.getNoServiceTooltipText();
                }

                return tooltipText;
            },

            toggleScrapperTab: function(e){
                LEManager.logger.debug("AttributesConfigItemView:toggleScrapperTab");
                if (!$(e.currentTarget).hasClass("selected")){
                    this.ui.scraperTab.addClass("selected");
                    this.ui.scraperContainer.addClass("selected");

                    this.ui.codeTab.removeClass("selected");
                    this.ui.agentTab.removeClass("selected");
                    this.ui.agentContainer.removeClass("selected");
                    this.ui.codeContainer.removeClass("selected");
                }
            },

            toggleCodeTab: function(e){
                LEManager.logger.debug("AttributesConfigItemView:toggleCodeTab");
                if (!$(e.currentTarget).hasClass("selected")){
                    this.ui.codeTab.addClass("selected");
                    this.ui.codeContainer.addClass("selected");

                    this.ui.agentTab.removeClass("selected");
                    this.ui.scraperTab.removeClass("selected");
                    this.ui.scraperContainer.removeClass("selected");
                    this.ui.agentContainer.removeClass("selected");
                }
            },

            toggleAgentTab: function(e){
                LEManager.logger.debug("AttributesConfigItemView:toggleAgentTab");
                if (!$(e.currentTarget).hasClass("selected")){
                    this.ui.agentTab.addClass("selected");
                    this.ui.agentContainer.addClass("selected");

                    this.ui.scraperTab.removeClass("selected");
                    this.ui.scraperContainer.removeClass("selected");
                    this.ui.codeTab.removeClass("selected");
                    this.ui.codeContainer.removeClass("selected");
                }
            },

            getModel: function(){
                LEManager.logger.debug("AttributesConfigItemView:getModel");
                return this.model;
            },

            getTooltipElements: function(type){
                LEManager.logger.debug("AttributesConfigItemView:getTooltipElements - type: " + type);
                if (!this.tooltipObject){
                    this.tooltipObject = this.model.getTooltipObject();
                }
                return _.has(this.tooltipObject, type) ? this.tooltipObject[type] : [];
            },

            showBubble: function(bubbleId, targetControl, view){
                LEManager.logger.debug("AttributesConfigItemView:showBubble");
                this.closeTooltip(bubbleId, true);
                this.uiComponents.host$.createAndRender(bubbleId, {
                    type: Bubble,
                    options: {
                        targetControl: targetControl,
                        contentView: view,
                        showCloseButton: false
                    }
                });
            },

            showScraperTooltip: function(){
                LEManager.logger.debug("AttributesConfigItemView:showScraperTooltip");
                this.tooltipContainerViewScraper = new TooltipContainerView({
                    tooltipArray: this.getTooltipElements(ManagerConfig.dataSources.mapping.editItem.SCRAPER),
                    displayKP: true,
                    KPResources: ManagerConfig.dataSources.mainConfig.walkme.resources.scraping,
                    tabType: ManagerConfig.dataSources.mainConfig.tabType.scraper
                });
                this.showBubble(scraperBubbleId, this.ui.scraperTooltipContainer, this.tooltipContainerViewScraper);
            },

            showCodeTooltip: function(){
                LEManager.logger.debug("AttributesConfigItemView:showCodeTooltip");
                 this.tooltipContainerViewCode = new TooltipContainerView({
                    tooltipArray: this.getTooltipElements(ManagerConfig.dataSources.mapping.editItem.CODE),
                    displayKP: true,
                    KPResources: ManagerConfig.dataSources.mainConfig.walkme.resources.code,
                    tabType: ManagerConfig.dataSources.mainConfig.tabType.code
                });
                this.showBubble(codeBubbleId, this.ui.codeTooltipContainer, this.tooltipContainerViewCode);
            },

            showAgentTooltip: function(){
                LEManager.logger.debug("AttributesConfigItemView:showAgentTooltip");
                this.tooltipContainerViewAgent = new TooltipContainerView({
                    tooltipArray: this.getTooltipElements(ManagerConfig.dataSources.mapping.editItem.AGENT),
                    displayKP: true,
                    KPResources: ManagerConfig.dataSources.mainConfig.walkme.resources.agent,
                    tabType: ManagerConfig.dataSources.mainConfig.tabType.agent
                });
                this.showBubble(codeBubbleId, this.ui.agentTooltipContainer, this.tooltipContainerViewAgent);
            },

            hideScraperTooltip: function(){
                LEManager.logger.debug("AttributesConfigItemView:hideScraperTooltip");
                if (this.uiComponents.hasOwnProperty(scraperBubbleId)){
                    this.closeTooltip(scraperBubbleId);
                }
            },

            hideCodeTooltip: function(){
                LEManager.logger.debug("AttributesConfigItemView:hideCodeTooltip");
                if (this.uiComponents.hasOwnProperty(codeBubbleId)){
                    this.closeTooltip(codeBubbleId);
                }
            },

            closeTooltip: function(id, force){
                LEManager.logger.debug("AttributesConfigItemView:closeTooltip");
                if (this.uiComponents.hasOwnProperty(id)){
                    this.uiComponents[id].close(force);
                }
            },

            _hideShowScrapperArea: function(hideScrapper){
                LEManager.logger.debug("AttributesConfigItemView:_hideShowScrapperArea - hideScrapper: " + hideScrapper);
                if(!hideScrapper){
                    var isTagletConfigSupported = this.channel.request(LE.mediaCodes.manager.reqres.isTagletConfigSupportedByDataSources);
                    this.uiComponents.host$.createAndRender("scraperView", {
                        type: isTagletConfigSupported ? ScraperView: ScraperNotSupportedView,
                        options: {
                            el : "view.ui.scraperContainer",
                            collection: this.model.getPropertiesCollection(),
                            attributeModel: this.model
                        }
                    });
                }
                else{
                    this._hideScrapperArea();
                }
            },

            _hideShowAgentArea: function(hideAgent){
                LEManager.logger.debug("AttributesConfigItemView:_hideShowScrapperArea - hideAgent: " + hideAgent);
                if(!hideAgent){
                    this.uiComponents.host$.createAndRender("agentView", {
                        type: AgentView,
                        options: {
                            el : "view.ui.agentContainer",
                            collection: this.model.getPropertiesCollection(),
                            model: this.model,
                            skillsCollection: this.skillsCollection
                        }
                    });
                }
                else{
                    this._hideAgentArea();
                }
            },

            _hideAgentArea: function(){
                LEManager.logger.debug("AttributesConfigItemView:_hideAgentArea");
                //hide the agent tab
                this.ui.agentTab.addClass("hide");
                this.ui.agentTab.removeClass("selected");
                this.ui.agentContainer.addClass("hide");
                this.ui.agentContainer.removeClass("selected");
            },

            _hideScrapperArea: function(){
                LEManager.logger.debug("AttributesConfigItemView:_hideScrapperArea");
                //hide the scrapper tab
                this.ui.scraperTab.addClass("hide");
                this.ui.scraperTab.removeClass("selected");
                this.ui.scraperContainer.addClass("hide");
                this.ui.scraperContainer.removeClass("selected");
                //select the code tab
                this.ui.codeTab.addClass("selected");
                this.ui.codeTab.addClass("single-tab");
                this.ui.codeContainer.addClass("selected");
                this.ui.codeContainer.addClass("single-tab");
            },

            onClose: function () {
                LEManager.logger.debug("AttributesConfigItemView:onClose");
            }

        });
    });

    return AttributesConfigItemView;
});
